import React from "react";
import { Flex } from "@mantine/core";

const Checkbox: React.FC<{
  isChecked: boolean;
  setChecked: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
  text?: string;
  color?: string;
  mode?: "check" | "cross";
  label?: string;
  className?: string;
  size?: "small" | "medium";
  icon?: string;
}> = ({
  isChecked,
  setChecked,
  disabled = false,
  text = null,
  mode = "check",
  color = "#00a76d",
  label,
  className,
  size,
  icon,
}) => {
  const doCheck = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disabled === true) {
      return null;
    } else {
      setChecked(e);
    }
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: size === "small" ? ".25rem" : ".5rem" }}
      className={className ?? ""}
    >
      {label != null && (
        <div>
          <span>{label}</span>
        </div>
      )}
      {isChecked === false && (
        <div
          onClick={(e) => doCheck(e)}
          style={{
            cursor: disabled ? "cursor" : "pointer",
            width: size === "small" ? "18px" : "25px",
            height: size === "small" ? "18px" : "25px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            border: `1px solid ${disabled ? "#ccc" : color}`,
          }}
        />
      )}
      {isChecked && (
        <Flex
          onClick={(e) => doCheck(e)}
          style={{
            cursor: disabled ? "cursor" : "pointer",
            width: size === "small" ? "18px" : "25px",
            height: size === "small" ? "18px" : "25px",
            borderRadius: "50%",
            backgroundColor: `${disabled ? "#ccc" : color}`,
            border: `1px solid ${disabled ? "#ccc" : color}`,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i
            className={`fa ${icon ? `fa-${icon}` : mode === "check" ? "fa-check" : "fa-close"}`}
            style={{ color: "#fff", fontSize: size === "small" ? "12px" : "1em" }}
          />
        </Flex>
      )}
      {text != null && (
        <span
          style={{
            fontSize: size === "small" ? "14px" : "1em",
            textDecoration: `${mode === "cross" && isChecked ? "line-through" : ""}`,
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
